import { createSlice } from "@reduxjs/toolkit";
import { GENERIC_RENEWAL_PAGE_SELECT_POLICY } from "../../pages/renewalPages/data";

const initialState = {
  selectedPolicy: null,
  policyType: null,
  currentStepIndex: 0,
  currentSubstepIndex: 0,
};

const genericRenewalFlowSlice = createSlice({
  name: "genericRenewalFlow",
  initialState,
  reducers: {
    setSelectedRenewalPolicy: (state, action) => {
      state.selectedPolicy = action.payload;
      state.policyType = action.payload?.ProductCode || null;
    },
    setGenericRenewalStep: (state, action) => {
      state.currentStepIndex = action.payload;
      state.currentSubstepIndex = 0;
    },
    setGenericRenewalSubstep: (state, action) => {
      state.currentSubstepIndex = action.payload;
    },
    clearGenericRenewalFlow: () => initialState,
  },
});

// Selectors
export const selectGenericRenewalFlow = (state) => state.genericRenewalFlow;
export const selectSelectedRenewalPolicy = (state) => state.genericRenewalFlow?.selectedPolicy;
export const selectGenericRenewalPolicyType = (state) => state.genericRenewalFlow?.policyType;
export const selectGenericRenewalStepIndex = (state) => state.genericRenewalFlow?.currentStepIndex;
export const selectGenericRenewalSubstepIndex = (state) => state.genericRenewalFlow?.currentSubstepIndex;

export const {
  setSelectedRenewalPolicy,
  setGenericRenewalStep,
  setGenericRenewalSubstep,
  clearGenericRenewalFlow,
} = genericRenewalFlowSlice.actions;

export default genericRenewalFlowSlice.reducer;
